<template>
  <div class="col s12 alarmsetting-page">
    <div class="row">
      <div class="col s12">
        <div class="section no-padding">
          <h5>Axlecounter</h5>
          <p>Alarmsetting</p>
        </div>
        <div class="divider"></div>
      </div>
    </div>
    <div class="row" v-show="!EditSettings">
      <div class="col s12">
        <p v-show="AlarmSettingItems.length === 0">No alarm settings available</p>
        <table class="striped" v-show="AlarmSettingItems.length !== 0">
          <thead>
            <tr>
              <th>Edit</th>
              <th>Alarm type</th>
              <th>1 Fbits</th>
              <th>2 Fbits</th>
              <th>3 Fbits</th>
              <th>4 Fbits</th>
              <th>Defect quantity</th>
              <th>Drift quantity</th>
              <th>Short wheel pulse</th>
              <th>Telegram failure rate</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in AlarmSettingItems" v-bind:key="index"
              v-show="index + 1 <= (paging.itemsPerPage * paging.selectedPage) &&
              index + 1 > ((paging.itemsPerPage * paging.selectedPage) -paging.itemsPerPage)">
              <td class="center-align"><i class="material-icons clickable" @click="Settings = item, EditSettings = true">edit</i></td>
              <td>{{item.AlarmType}}</td>
              <td>{{item.FailureBits1Quantity}}</td>
              <td>{{item.FailureBits2Quantity}}</td>
              <td>{{item.FailureBits3Quantity}}</td>
              <td>{{item.FailureBits4Quantity}}</td>
              <td>{{item.DefectQuantity}}</td>
              <td>{{item.DriftQuantity}}</td>
              <td>{{item.ShortWheelPulseQuantity}}</td>
              <td>{{item.TelegramFailureRateQuantity}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-show="EditSettings">
      <div class="col s12">

        <div class="row">
          <div class="col s1">Alarm type</div>
          <input class="col s3" type="text" v-model="Settings.AlarmType">
        </div>
        <div class="row">
          <div class="col s1">FBits 1</div>
          <input class="col s3" type="number" v-model="Settings.FailureBits1Quantity">
        </div>
        <div class="row">
          <div class="col s1">FBits 2</div>
          <input class="col s3" type="number" v-model="Settings.FailureBits2Quantity">
        </div>
        <div class="row">
          <div class="col s1">FBits 3</div>
          <input class="col s3" type="number" v-model="Settings.FailureBits3Quantity">
        </div>
        <div class="row">
          <div class="col s1">FBits 4</div>
          <input class="col s3" type="number" v-model="Settings.FailureBits4Quantity">
        </div>
        <div class="row">
          <div class="col s1">Defects</div>
          <input class="col s3" type="text" v-model="Settings.DefectQuantity">
        </div>
        <div class="row">
          <div class="col s1">Drift quantity</div>
          <input class="col s3" type="text" v-model="Settings.DriftQuantity">
        </div>
        <div class="row">
          <div class="col s1">Short wheel pulse</div>
          <input class="col s3" type="text" v-model="Settings.ShortWheelPulseQuantity">
        </div>
        <div class="row">
          <div class="col s1">Telegram failure rate</div>
          <input class="col s3" type="text" v-model="Settings.TelegramFailureRateQuantity">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <ul class="pagination center-align" v-if="paging.enabled && AlarmSettingItems.length > 0" v-show="!EditSettings">
          <li
            :class="{ disabled: paging.selectedPage === 1, 'waves-effect': paging.selectedPage > 1 }"
            @click="paging.selectedPage !== 1 && paging.selectedPage--">
            <i class="material-icons">chevron_left</i>
          </li>

          <li
            v-for="(pageNumber, index) in paging.numberOfPages" v-bind:key="index"
            class="waves-effect"
            :class="{ active: paging.selectedPage == pageNumber }"
            @click="paging.selectedPage = pageNumber"
          >
            <a>{{ pageNumber }}</a>
          </li>

          <li :class="{ disabled: paging.selectedPage === paging.numberOfPages, 'waves-effect': paging.selectedPage < paging.numberOfPages }"
            @click="paging.selectedPage !== paging.numberOfPages && paging.selectedPage++">
            <i class="material-icons">chevron_right</i>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="divider" style="margin-bottom: 12px"></div>
        <a v-show="EditSettings" class="waves-effect waves-light btn" @click="EditSettings = !EditSettings">Cancel</a>
        <a v-show="EditSettings" class="waves-effect waves-light btn" @click="saveSettings">Save</a>
      </div>
    </div>
  </div>
</template>

<script>
import AxleCounterService from '@/services/AxleCounterService'
import AxleCounterApi from '../../services/api/axlecounter/AxleCounterApi'

export default {
  data () {
    return {
      AlarmSettingItems: [],
      EditSettings: false,
      Settings: {
        AlarmSettingId: 0,
        AlarmType: 'F',
        DefectQuantity: 0,
        DriftQuantity: 0,
        FailureBits1Quantity: 0,
        FailureBits2Quantity: 0,
        FailureBits3Quantity: 0,
        FailureBits4Quantity: 0,
        RailObject: null,
        RailObjectId: 0,
        ShortWheelPulseQuantity: 0,
        TelegramFailureRateQuantity: 0
      },
      paging: {
        enabled: true,
        itemsPerPage: 15,
        numberOfPages: 0,
        selectedPage: 1,
        chevronLeftActive: false,
        chevronRightActive: false
      },
      maxRows: {
        startFrom: 0,
        nrOfRows: 100
      }
    }
  },
  mounted: function () {
    this.loadData()
  },
  watch: {
    '$route.params.railobjectid': {
      handler: function (val, oldVal) {
        this.loadData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    loadData: function () {
      if (this.$route.params.railobjectid) {
        this.Settings.RailObjectId = this.$route.params.railobjectid
      }
      this.getAlarmSettings()
    },
    getAlarmSettings: function () {
      this.AlarmSettingItems = []
      AxleCounterService.GetAlarmSettingsByRailobjectid(this.$route.params.railobjectid, this.maxRows.startFrom, this.maxRows.nrOfRows).then(result => {
        this.AlarmSettingItems = result.data
      }).then(() => {
        this.setPagingParameters()
      })
    },
    setPagingParameters: function () {
      this.paging.selectedPage = 1
      this.paging.numberOfPages = Math.ceil(this.AlarmSettingItems.length / this.paging.itemsPerPage)
    },
    saveSettings: function () {
      AxleCounterApi.updateAlarmSetting({
        railobjectid: this.Settings.RailObjectId,
        alarmSettingId: this.Settings.AlarmSettingId,
        alarmType: this.Settings.AlarmType,
        failureBits1Quantity: this.Settings.FailureBits1Quantity,
        failureBits2Quantity: this.Settings.FailureBits2Quantity,
        failureBits3Quantity: this.Settings.FailureBits3Quantity,
        failureBits4Quantity: this.Settings.FailureBits4Quantity,
        defectQuantity: this.Settings.DefectQuantity,
        driftQuantity: this.Settings.DriftQuantity,
        shortWheelPulseQuantity: this.Settings.ShortWheelPulseQuantity,
        telegramFailureRateQuantity: this.Settings.TelegramFailureRateQuantity
      }).then(resp => {
        if (resp.status !== 200) {
          alert(this.$t('axelecounter.somethingwentwrong'))
        } else {
          this.$notify({
            group: 'alerts',
            type: 'success',
            title: 'Saving',
            text: 'Succes'
          })
          this.getAlarmSettings()
          this.EditSettings = false
        }
      })
    }
  }
}

</script>

<style scoped>
.alarmsetting-page {
  overflow-y: auto;
  height: 84vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/axlecounter/_alarmSetting.vue